// extracted by mini-css-extract-plugin
export default {"menu":"GYVm7V"};